const TOKEN_KEY = 'hs_token'

const state = {
  token: localStorage.getItem(TOKEN_KEY) || '',
  userInfo: {}
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    localStorage.setItem(TOKEN_KEY, token)
  },
  SET_USER_INFO(state, info) {
    state.userInfo = info
  },
  CLEAR(state) {
    state.token = ''
    state.userInfo = {}
    localStorage.removeItem(TOKEN_KEY)
  }
}

const actions = {
  setToken({ commit }, token) {
    commit('SET_TOKEN', token)
  },
  setUserInfo({ commit }, info) {
    commit('SET_USER_INFO', info)
  },
  logout({ commit }) {
    commit('CLEAR')
  }
}

export default { namespaced: true, state, mutations, actions }

